// @flow

import type {MarkdocNodeRegistration} from 'docs/markdoc';

export const Paragraph: MarkdocNodeRegistration = {
  node: 'paragraph',
  component: 'Paragraph',
  children: ['inline'],
};
